export class VehicleBrand {

  id: string;
  name: string;

  constructor(other?: VehicleBrand) {
    if (other) {
      this.id = other.id;
      this.name = other.name;
    }
  }

  toString() {
    return this.name;
  }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/vehicleBrand.ts
 **/